import ThumbUpSolid from './ThumbUpSolid'

export default ThumbUpSolid
// eslint-disable-next-line import/export
export * from './ThumbUpSolid'
